"use strict";

exports.__esModule = true;
exports["default"] = void 0;
//@ts-check

/**
 * @param {string} s
 * @returns {string}
 */
var ucfirst = function ucfirst(s) {
  var _;
  var f = (_ = (s !== null && s !== void 0 ? s : "")[0]) === null || _ === void 0 ? void 0 : _.toUpperCase();
  return f ? f + s.slice(1) : null;
};
var _default = ucfirst;
exports["default"] = _default;
module.exports = exports.default;